import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehiclequalification/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getYeHuList = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehiclequalification/getyehulist' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const makePackage = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehiclequalification/makepackage' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const downloadPackage = (params, urlParams) => {
  return axios.request({
    url: '/gdviss/gddlysjgvehiclequalification/downloadpackage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

